/**
 * Leaving the app for somewhere else, in one function.
 *
 * Checkout and the billing portal are pages Stripe hosts, reached by a url the API hands back
 * rather than by a link that could be written down here, so this is a navigation rather than a
 * route change: the router must not try to match it. It is one line, and it is its own module so
 * that a test can watch where the app tried to send somebody without a jsdom window pretending to
 * navigate.
 */
export function leaveFor(url: string): void {
  window.location.assign(url);
}
